import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import jwt_decode from 'jwt-decode';
@Component({
  selector: 'app-login-token',
  templateUrl: './login-token.component.html',
  styleUrls: ['./login-token.component.scss']
})
export class LoginTokenComponent implements OnInit {
  
  token: string;

  constructor(
    public router: Router,
    private _route: ActivatedRoute) { 
      this.token = '';
    }

  ngOnInit(): void {

    let token_url:any = this._route.snapshot.paramMap.get('token');
    
      localStorage.setItem('access_token', token_url);

      let token:string = localStorage.getItem('access_token')!;

      let decoded:any = jwt_decode(token); 
      
      localStorage.setItem('companyId', decoded.emp);

      localStorage.setItem('brandId', decoded.brn);

    if (window.localStorage.getItem('access_token')){
      this.router.navigate(['/panel']);
  }
  }

}
